var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demand"},[_c('div',{staticClass:"demandMark"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("产权登记")]),_c('img',{attrs:{"src":require("../../assets/wrong.png"),"alt":""},on:{"click":_vm.closeAlert}})]),(_vm.$store.getters.equityStatus)?_c('succe'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }